import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PersonalInfoRequestHelper  {
    _originalTypeClassName = "zSHR.BO.PersonalInfoRequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PersonalInfoRequestHelper.translate = translateService;
}
this.PersonalInfoRequestHelperKey = null;
this._key = this.PersonalInfoRequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PersonalInfoRequestHelperKey:any;
get PersonalInfoRequestHelperKey(): any {
    return this._PersonalInfoRequestHelperKey;
  }
set PersonalInfoRequestHelperKey(value: any) {
    this._PersonalInfoRequestHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PersonalInfoRequestHelperKey == null || $this.PersonalInfoRequestHelperKey == 0;
            }


}